import React, { Component } from 'react'
import { Card, Descriptions, List, Table, } from 'antd';
import { withTranslation } from "react-i18next";
import { StatusComponent } from '../../../common/component/Index';
import { DATE_TIME_FORMAT, PATHS } from '../../../../../constants/Define'
import * as Func from '../../../../../helpers/functions';
import moment from 'moment';
import './InfoCode.less'
import { Link } from 'react-router-dom';
import { generateStringId } from '../../../../../utils/orders';

const { Item } = Descriptions

class InfoCode extends Component {

    constructor(props) {
        super(props)
        this.state = {
            columns: [
                {
                  title: this.props.t('item.promotions.orderCode'),
                  dataIndex: 'orderCode',
                  key: 'orderCode',
                  render: (text, record) => text && <Link to={Func.getPathWithParams(PATHS.ORDER.DETAIL.path, { id: record.orderId })} target="_blank">{text}</Link>
                },
                {
                  title: this.props.t('item.promotions.usedTime'),
                  dataIndex: 'usedTime',
                  key: 'usedTime',
                  render: (date, record) => date && moment(moment.utc(date).toDate()).format(DATE_TIME_FORMAT.DATE_TIME)
                },
            ]
        }
    }

    render() {
        const { data, t } = this.props;
        const { columns } = this.state;

        return (
            <Card size="small">
                <div className="row">
                    <div className="col-md-6">
                        <Descriptions bordered title={t('item.promotions.promotionInfo')} bordered column={2} size='large' className="m-b">
                            <Item label={t('item.promotions.campaignName')} >{data.campaignName}</Item>
                            <Item label={t('item.promotions.bundleName')} >{data.bundleName}</Item>
                            <Item label={t('item.promotions.status')}>
                                <StatusComponent color={data.isActive ? 'green' : 'red'}
                                    label={data.isActive ? t('item.promotions.active') : t('item.promotions.deactive')} />
                            </Item>
                            <Item label={t('item.promotions.maxCount')}>
                                {
                                    data.maxCount <= 0 ?
                                        <StatusComponent color={'green'} label={t('item.promotions.unlimited')} />
                                    :  data.maxCount}
                            </Item>
                            <Item label={t('item.promotions.usedCount')}>{data.usedCount}</Item>
                        </Descriptions>
                    </div>
                    <div className="col-md-6">
                        <b className="title-check-code">Danh sách đơn hàng sử dụng</b>
                        <div className="list-used">
                            <Table 
                                className="table-history m-t" 
                                dataSource={data.promotionHistories} 
                                columns={columns} 
                                bordered
                                rowKey={record => (generateStringId(10) + record.orderCode)}
                                scroll={{ y: 300 }}
                                pagination={{ defaultPageSize: 1000 }}
                            />
                        </div>
                    </div>
                </div>
            </Card>
        )
    }
}

export default withTranslation()(InfoCode)
